import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.acciforum.com";
export const OTHER_API_URL = process.env.REACT_APP_OTHER_API_URL || "https://api.acciforum.com";
export const ASSETS_BASE_URL = "https://api.acciforum.com";


// Primary API instance (9876)
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Secondary API instance (8096)
export const otherApi = axios.create({
  baseURL: OTHER_API_URL,
});   

export default api;
